import { Edit, Form, Input, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ITrackKey } from "types/trackkey.interface";

export const TrackKeyEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, formLoading } = useForm<ITrackKey>();

  const { queryResult } = useShow<ITrackKey>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="MusicKey"
          name="musicKey"
          rules={[
            {
              required: true,
              message: "Music Key is required",
            },
          ]}
          initialValue={record?.data.musicKey}
        >
          <Input defaultValue={record?.data.musicKey} />
        </Form.Item>
        <Form.Item
          label="CamelotKey"
          name="camelotKey"
          rules={[
            {
              required: true,
              message: "Camelot Key is required",
            },
          ]}
          initialValue={record?.data.camelotKey}
        >
          <Input defaultValue={record?.data.camelotKey} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
